import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BreadCrumbModule } from './breadcrumb/breadcrumb.module';
import { ButtonModule } from './button/button.module';
import { CarouselModule } from './carousel/carousel.module';
import { CountdownModule } from './countdown/countdown.module';
import { HeroModule } from './hero/hero.module';
import { IconsModule } from './icons/icons.module';
import { ModalModule } from './modal/modal.module';
import { NotificationModule } from './notification/notification.module';
import { OptionsModule } from './options/options.module';
import { PriceModule } from './price/price.module';
import { RatingModule } from './rating/rating.module';
import { SliderModule } from './slider/slider.module';
import { StickyModule } from './sticky/sticky.module';
import { TabsModule } from './tabs/tabs.module';
import { ToggleModule } from './toggle/toggle.module';
import { ZoomModule } from './zoom/zoom.module';

@NgModule({
    declarations: [],

    imports: [
        CommonModule,
        CarouselModule,
        RouterModule,
        ButtonModule,
        IconsModule,
        ZoomModule,
        ModalModule,
        HeroModule,
        PriceModule,
        NotificationModule,
        TabsModule,
        RatingModule,
        StickyModule,
        SliderModule,
        CountdownModule,
        BreadCrumbModule,
        OptionsModule,
        ToggleModule,
    ],

    exports: [
        CommonModule,
        CarouselModule,
        RouterModule,
        ButtonModule,
        IconsModule,
        ZoomModule,
        ModalModule,
        HeroModule,
        PriceModule,
        NotificationModule,
        TabsModule,
        RatingModule,
        StickyModule,
        SliderModule,
        CountdownModule,
        BreadCrumbModule,
        OptionsModule,
        ToggleModule,
    ],
})
export class ComponentsModule {}
